import { Helmet } from "react-helmet-async";

import { generateSchemaMarkup } from "content/landing";

/**
 * Renders JSON-LD structured data for the landing page via react-helmet-async.
 * Includes Organization, WebSite, WebPage, SoftwareApplication, and FAQPage schemas.
 */
export function LandingSchemaMarkup(): JSX.Element {
  const schema = generateSchemaMarkup();

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
